import { reactular } from '@vendhq/reactular'
import React from 'react'
import { useT } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import { selectActiveRegisterId } from '../../../state/slices/posState/posStateSlice'
import { useFetchPairing } from '../lspay-payment-modal/hooks/useFetchPairing'
import { useTerminalStatusFromRedux } from './useTerminalStatusFromRedux'
import { getWarningConfig } from './terminal-status-event-handler'

export const TerminalStatusBarComponent: React.FC = () => {
  const t = useT()
  const registerId = useAppSelector(selectActiveRegisterId)
  const { pairing } = useFetchPairing(registerId ?? '')
  const { warningType } = useTerminalStatusFromRedux()

  if (!warningType || !pairing) {
    return null
  }

  const warning = getWarningConfig(t, pairing.deviceLabel)[warningType]
  const styleModifier =
    warningType === 'offline' || warningType === 'busy' ? 'error' : 'warning'

  return (
    <div className={`terminal-status-bar ${styleModifier}`}>
      <span>
        {warning.icon} <strong>{warning.title}</strong> {warning.barMessage}
      </span>
    </div>
  )
}

export const ReactTerminalStatusBarComponent = reactular(
  TerminalStatusBarComponent,
  [],
  'reactWrapper'
)
